// 📈 추적 링크 저장/조회 서비스 (inflow_links 컬렉션)
// 관리자가 생성한 utm 추적 링크를 저장해 팀 전체가 공유·재사용할 수 있게 함

import { db } from '../firebase';
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  Timestamp,
} from 'firebase/firestore';

export interface InflowLinkInput {
  source: string;            // 정규화된 utm_source
  medium: string;            // utm_medium
  campaign: string;          // utm_campaign
  target: 'b2b' | 'b2c';     // 랜딩 페이지 구분
  url: string;               // 생성된 전체 URL
  created_by: string;        // 등록한 관리자 이메일
}

export interface InflowLink extends InflowLinkInput {
  id: string;
  created_at: { seconds: number } | null;
}

const linksRef = collection(db, 'inflow_links');

/** 추적 링크 저장 */
export async function createInflowLink(input: InflowLinkInput): Promise<string> {
  const docRef = await addDoc(linksRef, {
    ...input,
    created_at: Timestamp.now(),
  });
  return docRef.id;
}

/** 저장된 추적 링크 전체 조회 (최신순) */
export async function fetchInflowLinks(): Promise<InflowLink[]> {
  const snapshot = await getDocs(query(linksRef, orderBy('created_at', 'desc')));
  return snapshot.docs.map((d) => ({
    id: d.id,
    ...(d.data() as Omit<InflowLink, 'id'>),
  }));
}

/** 추적 링크 삭제 */
export async function deleteInflowLink(id: string): Promise<void> {
  await deleteDoc(doc(db, 'inflow_links', id));
}
